import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup } from 'react-bootstrap';
import {
  Divider,
  Heading,
  FormBox,
  Footer,
} from '../../StyledComponents/StyledComponents';
import ComponentHelper from '../../../helpers/ComponentHelper';

class Declaration extends Component {
  render() {
    const { content, formValues, form } = this.props;
    return (
      <>
        <FormGroup>
          <Col sm={12}>
            <Heading>Agency - Declaration</Heading>
          </Col>
        </FormGroup>
        <FormBox>
          <ComponentHelper
            contentFields={content.fields}
            formValues={formValues}
            labelSize={8}
            colSize={4}
            form={form}
          />

          <Divider />

          <Footer>
            In applying for this agency we must emphasise that both parties will each be
            required to comply with our respective responsibilities in relation to
            financial crime, which includes, but is not limited to Money Laundering, The
            Bribery Act 2000, Financial Sanctions, and the Data Protection Act 1998
          </Footer>
        </FormBox>
      </>
    );
  }
}

export default connect(() => {
  return {
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  };
})(Declaration);
